import { SKILLS } from "./skills";
import type { McpServerId } from "../types/mcp";
import { writeAttachedConnectorIds } from "./chat-connector-attachments";

export function activateSkillConnectors(
  skillId: string,
  scopeId?: string | null,
): McpServerId[] {
  const skill = SKILLS.find((item) => item.id === skillId);
  if (!skill?.mcpServers?.length) return [];
  const connectorIds = [...new Set(skill.mcpServers)] as McpServerId[];
  if (scopeId) writeAttachedConnectorIds(scopeId, connectorIds);
  return connectorIds;
}
